import type { Client, RequestContext } from "../client";
import { Repository } from "../repository";
import type { ProcessTemplateSummary, ProcessTemplateResource, DeleteProcessTemplateCommand, ModifyProcessTemplateCommand, GitRef, NewProcessTemplate, PublishProcessTemplateBffCommand, ProcessTemplateVersionResource, ShareTemplateToManySpacesBffCommand, ShareTemplateToManySpacesBffResponse, GetSharedSpacesToProcessTemplateBySlugBffResponse, ProcessTemplateListSummaryResource, ProcessTemplateVersionSummary, GitLinkResult, } from "../resources";
export class ProcessTemplateRepository {
    protected readonly client: Client;
    protected readonly context: RequestContext;
    constructor(client: Client, requestContext: RequestContext) {
        this.client = client;
        this.context = requestContext;
    }
    summaries() {
        return this.client.get<ProcessTemplateListSummaryResource[]>(this.context, "~/bff/spaces/{spaceId}/processtemplates/summaries");
    }
    get(slug: string, gitRef: GitRef) {
        return this.client.get<ProcessTemplateResource>(this.context, "~/bff/{gitRef}/processtemplates/{slug}", { slug, gitRef });
    }
    getByVersionMask(slug: string, versionMask: string) {
        return this.client.get<GetProcessTemplateByVersionMaskOrLatestBffResponse>(this.context, "~/bff/spaces/{spaceId}/processtemplates/{slug}{?versionMask}", { slug, versionMask });
    }
    getLatestVersionSummary(slug: string) {
        return this.client.get<ProcessTemplateVersionSummary>(this.context, "~/bff/spaces/{spaceId}/processtemplates/{slug}/versionsummary", { slug });
    }
    del(deleteProcessTemplateCommand: DeleteProcessTemplateCommand) {
        return this.client.post(this.context, "~/bff/processtemplates/delete-by-id", deleteProcessTemplateCommand);
    }
    add(processTemplate: NewProcessTemplate, gitRef: GitRef) {
        return this.client.post<ProcessTemplateResource>(this.context, "~/bff/platformhub/{gitRef}/processtemplates", processTemplate, { gitRef });
    }
    modify(processTemplate: ModifyProcessTemplateCommand) {
        return this.client.put<ProcessTemplateResource>(this.context, "~/bff/processtemplates/{processTemplateId}", processTemplate, { processTemplateId: processTemplate.Id });
    }
    getPaginatedTemplates(processTemplatesPageFilter: GetProcessTemplatesBffRequest): Promise<GetProcessTemplatesBffResponse> {
        return this.client.get<GetProcessTemplatesBffResponse>(this.context, "~/bff/{gitRef}/processtemplates{?skip,take,partialName}", processTemplatesPageFilter);
    }
    publishVersion(publishCommand: PublishProcessTemplateBffCommand) {
        return this.client.post<ProcessTemplateVersionResource>(this.context, "~/bff/platformhub/{gitRef}/processtemplates/{slug}/publish", publishCommand, { slug: publishCommand.ProcessTemplateSlug, gitRef: publishCommand.GitRef });
    }
    getVersions(slug: string) {
        return this.client.get<ProcessTemplateVersionResource[]>(this.context, "~/bff/platformhub/processtemplates/{slug}/versions{?skip,take}", { slug, skip: 0, take: Repository.takeAll });
    }
    shareToSpace(shareCommand: ShareTemplateToManySpacesBffCommand) {
        return this.client.post<ShareTemplateToManySpacesBffResponse>(this.context, "~/bff/platformhub/{gitRef}/processtemplates/{slug}/share", shareCommand, { slug: shareCommand.ProcessTemplateSlug, gitRef: shareCommand.GitRef });
    }
    getSharedSpaces(slug: string) {
        return this.client.get<GetSharedSpacesToProcessTemplateBySlugBffResponse>(this.context, "~/bff/platformhub/processtemplates/{slug}/share", { slug });
    }
    getVariableNames(slug: string, gitRef: string | undefined) {
        return this.client.get<string[]>(this.context, "~/bff/platformhub/{gitRef}/processtemplates/{slug}/variables/names", { slug, gitRef });
    }
    getLink(slug: string, gitRef: GitRef) {
        return this.client.get<GitLinkResult>(this.context, "~/bff/platformhub/{gitRef}/processtemplates/{slug}/link", { slug, gitRef });
    }
}
export type GetProcessTemplatesBffRequest = {
    skip: number;
    take: number;
    partialName?: string;
    gitRef: string;
};
export interface GetProcessTemplatesBffResponse {
    ProcessTemplates: ProcessTemplateSummary[];
    TotalResults: number;
    ItemsPerPage: number;
    TotalNoOfProcessTemplates: number;
}
export interface GetProcessTemplateByVersionMaskOrLatestBffResponse {
    ProcessTemplate: ProcessTemplateResource;
    ProcessTemplateVersion: string;
}
